import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Util } from '../../../utils/util';

@Component({
	selector: 'app-registration-update-modal',
	templateUrl: './registration-update-modal.component.html',
	styleUrls: ['./registration-update-modal.component.styl']
})
export class RegistrationUpdateModalComponent {
	constructor(
		public dialogRef: MatDialogRef<RegistrationUpdateModalComponent>,
	) {}

	close(): void {
		this.dialogRef.close();
	}

	get isMobile() {
		return Util.isMobile();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/registration-update-modal/registration-update-modal.component.ts